module.exports = __webpack_public_path__ + "static/media/tr logo.a9f8f9c8.png";